import { UnifiedGraftModelType } from '@graftcode/protocol'

/**
 * Returns the UnifiedGraftModelType enum key name (e.g. "INSTANCE_METHOD") from a string or numeric value.
 * Used for badges and type checks when only the enum value is available.
 */
export const getEnumKeyName = (value: UnifiedGraftModelType | string | number): string => {
  if (typeof value === 'string') {
    return value
  }
  if (typeof value === 'number') {
    return UnifiedGraftModelType[value] || String(value)
  }
  const enumKey = Object.keys(UnifiedGraftModelType).find(
    (key) => UnifiedGraftModelType[key as keyof typeof UnifiedGraftModelType] === value
  )

  return enumKey || String(value)
}
